<template>
    <div component="HomeCircles">
        <div class="circle red">
            <slot name="red"></slot>
        </div>
        <div class="circle white">
            <slot name="white"></slot>
        </div>
        <div class="circle grey">
            <slot name="grey"></slot>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'HomeCircles',
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='HomeCircles'] {
    position: relative;
    display: flex;

    &.about {
        margin: 50px 0;
    }

    .circle {
        .flex-center;
        flex-direction: column;
        width: 140px;
        min-width: 140px;
        height: 140px;
        border-radius: 50%;
        color: #fff;
        position: relative;
        font-weight: bold;
        line-height: 1.3;

        &.red {
            background-color: #e21e25;
            z-index: 100;
            margin-top: 55px;
        }

        &.white {
            background-color: #fff;
            color: black;
            z-index: 99;
            margin-left: -35px;
            margin-top: 0px;

            a[href^='tel'] {
                background-color: fade(black, 10%);

                &:hover {
                    background-color: fade(black, 20%);
                }
            }
        }

        &.grey {
            background-color: #454545;
            margin-left: -130px;
            margin-top: 110px;
        }

        i {
            font-weight: normal;
            font-style: normal;
        }
    }

    span {
        font-size: 37px;
        font-weight: 200;
        line-height: 1;
    }

    strong {
        text-align: center;
        font-size: 13px;
    }

    .name {
        position: absolute;
        font-weight: 800;
        color: black;
        font-size: 17px;
        width: 125px;
        white-space: nowrap;
    }
    .name.w {
        left: 0px;
        top: -50px;
        color: @black;

        @media (min-width: 520px) {
            left: -20px;
        }
    }
    .name.r {
        left: -30px;
        bottom: -50px;
        color: @black;

        @media (min-width: 520px) {
            left: -70px;
        }
    }
    .name.g {
        bottom: -50px;
        right: -20px;
    }
    small {
        font-size: 15px;
        font-weight: 200;
    }
    .inside {
        display: flex;
        flex-direction: column;
        text-align: center;
        position: absolute;
        height: 100px;
        width: 100px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        overflow: hidden;

        a {
            width: 100%;
            height: 50%;
            color: white;
            .flex-center;
            transition: 0.5s;

            .icon {
                font-size: 24px;
            }
        }

        a[href^='tel'] {
            background-color: fade(white, 20%);
            width: 100%;
            height: 50%;

            &:hover {
                background-color: fade(white, 60%);
            }
        }

        a[href^='mailto'] {
            background-color: fade(black, 40%);

            &:hover {
                background-color: fade(black, 90%);
            }
        }
    }
}
</style>
